export default __webpack_public_path__ + "static/media/alcoholbook2.92dfaca8.jpg";